var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurlplewave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 94,
    viewBox: "0 0 151 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.7305 -88.8046C92.0733 -92.1434 98.3316 -91.3173 101.672 -86.9641L161.849 -8.5511C165.193 -4.19327 164.374 2.06726 160.031 5.40613L103.875 48.58C87.3606 61.277 63.589 58.1389 50.8848 41.5847L24.6644 7.41828C11.9602 -9.13589 15.0603 -32.9337 31.575 -45.6306L87.7305 -88.8046ZM87.3743 -89.2687L31.2188 -46.0947C14.4217 -33.1806 11.2799 -9.06303 24.2014 7.77423L50.4218 41.9407C63.3433 58.778 87.4343 61.9582 104.231 49.0441L160.387 5.87022C164.994 2.32846 165.856 -4.28934 162.312 -8.90705L102.135 -87.3201C98.5915 -91.9378 91.981 -92.8104 87.3743 -89.2687Z",
    fill: "url(#paint0_linear_1309_125187)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9424 -87.5606C103.6 -94.2169 116.068 -92.5711 122.728 -83.8926L170.87 -21.1613C177.53 -12.4828 175.904 -0.00161344 167.246 6.65477L114.503 47.2053C100.424 58.0299 80.1533 55.3582 69.319 41.2405L36.3066 -1.77619C25.4758 -15.8892 28.1151 -36.1819 42.1991 -47.01L94.9424 -87.5606ZM94.5862 -88.0247L41.8429 -47.4741C27.4811 -36.4324 24.7955 -15.8164 35.8436 -1.42023L68.856 41.5965C79.9005 55.988 100.497 58.7111 114.859 47.6694L167.607 7.11529C176.533 0.252457 178.208 -12.5685 171.337 -21.5208L123.195 -84.2521C116.32 -93.2009 103.517 -94.891 94.5862 -88.0247Z",
    fill: "url(#paint1_linear_1309_125187)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.159 -86.3201C115.132 -96.294 133.8 -93.8296 143.78 -80.8258L179.884 -33.7807C189.863 -20.7769 187.429 -2.08797 174.456 7.88592L125.115 45.8202C113.467 54.776 96.7035 52.5589 87.7461 40.887L47.9453 -10.9753C38.9843 -22.6519 41.1746 -39.4336 52.8187 -48.3859L102.159 -86.3201ZM101.803 -86.7842L52.4626 -48.85C40.5407 -39.6841 38.3112 -22.5697 47.4823 -10.6193L87.2831 41.243C96.4542 53.1933 113.55 55.4501 125.472 46.2843L174.807 8.35358C188.058 -1.83389 190.532 -20.8554 180.342 -34.1331L144.238 -81.1781C134.053 -94.4594 115.049 -96.9681 101.803 -86.7842Z",
    fill: "url(#paint2_linear_1309_125187)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.371 -85.0761C126.654 -98.3639 151.536 -95.0834 164.835 -77.7542L188.905 -46.3909C202.2 -29.0663 198.959 -4.1568 181.671 9.1346L135.743 44.4455C126.53 51.529 113.268 49.7783 106.18 40.5428L59.5875 -20.1697C52.4999 -29.4051 54.2294 -42.6817 63.4428 -49.7652L109.371 -85.0761ZM109.015 -85.5402L63.0867 -50.2293C53.6047 -42.9394 51.8304 -29.3183 59.1245 -19.8137L105.717 40.8988C113.011 50.4034 126.617 52.1995 136.099 44.9095L182.027 9.5987C199.598 -3.90984 202.884 -29.1345 189.368 -46.7468L165.298 -78.1102C151.782 -95.7225 126.585 -99.0487 109.015 -85.5402Z",
    fill: "url(#paint3_linear_1309_125187)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116.588 -83.8357C138.186 -100.441 169.273 -96.3373 185.887 -74.6874L197.922 -59.0057C214.537 -37.3558 210.483 -6.23498 188.885 10.3704L146.364 43.0614C139.586 48.2726 129.825 46.9883 124.607 40.1893L71.2299 -29.3642C66.0157 -36.1585 67.2845 -45.9299 74.0672 -51.1446L116.588 -83.8357ZM116.232 -84.2998L73.7111 -51.6087C66.6644 -46.1911 65.3462 -36.0717 70.7669 -29.0082L124.152 40.5545C129.572 47.618 139.681 48.9524 146.727 43.5348L189.248 10.8438C211.138 -5.98585 215.228 -37.4147 198.392 -59.3524L186.35 -75.0433C169.515 -96.9809 138.117 -101.126 116.232 -84.2998Z",
    fill: "url(#paint4_linear_1309_125187)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M123.8 -82.5915C149.713 -102.514 187.009 -97.591 206.943 -71.6157C226.877 -45.6405 222.014 -8.30372 196.1 11.6191L156.987 41.6903C152.64 45.0328 146.386 44.203 143.045 39.8499L82.8688 -38.5631C79.5244 -42.921 80.3441 -49.1815 84.687 -52.5204L123.8 -82.5915ZM123.444 -83.0556L84.3308 -52.9845C79.7241 -49.4427 78.862 -42.8249 82.4058 -38.2072L142.582 40.2058C146.126 44.8235 152.737 45.6962 157.343 42.1544L196.456 12.0832C222.666 -8.06744 227.568 -45.6995 207.406 -71.9717C187.244 -98.244 149.653 -103.206 123.444 -83.0556Z",
    fill: "url(#paint5_linear_1309_125187)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1309_125187",
    x1: 71.215,
    y1: 12.0536,
    x2: 103.151,
    y2: 37.5275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0360106,
    stopColor: "#BBF8E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542776,
    stopColor: "#3FECC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E45BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1309_125187",
    x1: 86.2548,
    y1: 7.28366,
    x2: 118.193,
    y2: 32.7588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0360106,
    stopColor: "#BBF8E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542776,
    stopColor: "#3FECC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E45BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1309_125187",
    x1: 101.284,
    y1: 2.5086,
    x2: 133.219,
    y2: 27.9813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0360106,
    stopColor: "#BBF8E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542776,
    stopColor: "#3FECC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E45BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1309_125187",
    x1: 116.324,
    y1: -2.26131,
    x2: 148.261,
    y2: 23.2126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0360106,
    stopColor: "#BBF8E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542776,
    stopColor: "#3FECC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E45BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1309_125187",
    x1: 131.363,
    y1: -7.03026,
    x2: 163.301,
    y2: 18.4445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0360106,
    stopColor: "#BBF8E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542776,
    stopColor: "#3FECC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E45BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1309_125187",
    x1: 146.398,
    y1: -11.8045,
    x2: 178.334,
    y2: 13.6694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0360106,
    stopColor: "#BBF8E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542776,
    stopColor: "#3FECC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E45BA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurlplewave);
export default __webpack_public_path__ + "static/media/purlplewave.08ad55d42c081dd9c6f8419dabfacafe.svg";
export { ForwardRef as ReactComponent };